import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { FormattedMessage as Translation } from 'react-intl';
import cx from 'classnames';
import useValuationResults from "../useValuationResults";
import ReactMarkdown from 'react-markdown';
import InputRadioButton from "./InputRadioButton";
var css = {
  "bookAppointment": "oalp-1tIXD",
  "bookAppointment__heading": "oalp-1AelE",
  "bookAppointment__subtext": "oalp-58FFJ",
  "bookAppointment__subPos": "oalp-1ys16",
  "priceContent": "oalp-uGLU0",
  "priceContent__desktop": "oalp-2A7BU",
  "priceContent__truePrice": "oalp-1zE7i",
  "priceContent__priceRange": "oalp-3bCyg",
  "priceContent__conditions": "oalp-2t2Ro",
  "priceContent__aboutConditions": "oalp-RRFTU",
  "bookAppointment__subfooter": "oalp-1rU4g",
  "bookAppointment__btnContainer": "oalp-SBRMI",
  "ctaBtn": "oalp-2Aq9F",
  "bookAppointment__terms": "oalp-2gE2S",
  "bookAppointment__benefits": "oalp-1x65c",
  "bookAppointment__benefitRow": "oalp-2Upp_",
  "bookAppointment__header": "oalp-3LQoK",
  "bookAppointment__headerText": "oalp-3N17w",
  "bookAppointment__subHeader": "oalp-2d5DU",
  "bookAppointment__subHeaderLeft": "oalp-rd2rI",
  "bookAppointment__subHeaderRight": "oalp-23zZC",
  "bookAppointment__subHeader__title": "oalp-XWseo",
  "bookAppointment__subHeader__subTitle": "oalp-1h6DZ",
  "bookAppointment__logo": "oalp-1wiEl",
  "bookAppointment__headerImage": "oalp-1w-s1",
  "bookAppointment__editBtn": "oalp-Z5B72",
  "bookAppointmentV2": "oalp-2GDzg",
  "bookAppointmentV2__headerWrapper": "oalp-21y1f",
  "bookAppointmentV2__graph": "oalp-3o32E",
  "bookAppointmentV2__selected": "oalp-3ZTLR",
  "bookAppointmentV2__imageLoop": "oalp-1eNIP",
  "bookAppointmentV2__conditionText": "oalp-2yz90",
  "bookAppointmentV2__imageText": "oalp-1G0WV",
  "bookAppointmentV2__carProps": "oalp-25tVf",
  "bookAppointmentV2__carProps__condition": "oalp-1VeOL",
  "bookAppointmentV2__carProps__condition_textHead": "oalp-1ivhg",
  "bookAppointmentV2__carProps__condition_textVal": "oalp-3pZEU",
  "bookAppointmentV2__carProps__features": "oalp-3-XVq",
  "bookAppointmentV2__carProps__features_prop": "oalp-8x7_8",
  "bookAppointmentV2__carProps__features_prop_icon": "oalp-2jFaO",
  "bookAppointmentV2__carProps__features_prop_text": "oalp-QGcoX",
  "priceContent__arrow": "oalp-2XWbi",
  "bookAppointmentV2__subHeader": "oalp-3CijZ",
  "bookAppointmentV2__subHeaderLeft": "oalp-1dn1N",
  "bookAppointmentV2__subHeaderLeft_mileage": "oalp-3gRrT",
  "bookAppointmentV2__subHeader__title": "oalp-1zD2j",
  "bookAppointmentV2__subHeader__subTitle": "oalp-W5WYm",
  "bookAppointmentV2__subHeaderRight": "oalp-1Zqfe",
  "bookAppointmentV2__editIconWithText": "oalp-Ik_ey",
  "bookAppointmentV2__editText": "oalp-QnJr1",
  "bookAppointmentV2__editBtn": "oalp-35Y_w",
  "bookAppointmentV2__ctaCont": "oalp-cPazQ",
  "bookAppointmentV2__ctaGroup": "oalp-1Vule",
  "bookAppointmentV2__ctaGroup_ctaBtn": "oalp-3F_w-",
  "bookAppointmentV2__q2bCarDetailsWrapper": "oalp-khfGO",
  "bookAppointmentV2__q2bPrefixSuffix": "oalp-3W_On",
  "bookAppointmentV2__qtbEditAlign": "oalp-25jJV",
  "bookAppointmentV2__revamp": "oalp-AkA6E",
  "headerWrapper": "oalp-3ag62",
  "carDetails__text": "oalp-rdKQs",
  "carDetails__text--bold": "oalp-1vSCU",
  "carDetails__text--light": "oalp-3h8yJ",
  "editBtnWrapper": "oalp-1Im-N",
  "editBtn": "oalp-259K1",
  "editBtnTR": "oalp-3Ifuy",
  "detailsContentWrapper": "oalp-2TEWu",
  "conditionsList": "oalp-fbIh2",
  "conditionsList__item": "oalp-2hBCT",
  "conditionsList__item--active": "oalp-3WzZP",
  "conditionsList__item__text": "oalp-2Y4o2",
  "contentWrapper": "oalp-1vkHa",
  "contentWrapperWithPrice": "oalp-2W0RH",
  "withPadding--small": "oalp-3r3Mu",
  "withPadding--large": "oalp-3NfFe",
  "withBorderTop": "oalp-2a3Fz",
  "withBgColor": "oalp-1OYbM",
  "contentWrapper__arrow": "oalp-xJRnY",
  "contentWrapperWithPrice__arrow": "oalp-1NcbD",
  "content": "oalp-1xWwR",
  "priceWrapper": "oalp-2hVb8",
  "price": "oalp-37cPk",
  "price--mobile": "oalp-9wrCW",
  "priceTR": "oalp-2aX1v",
  "priceText": "oalp-1EROH",
  "condition-details": "oalp-2ylgm",
  "condition-details__title": "oalp-Duo4U",
  "detailsList": "oalp-3N3LP",
  "detailsList__item": "oalp-XqONa"
};
import ConditionModal from "../ConditionModal";
import ImageWrapper from "../../../Components/ImageWrapper/ImageWrapper";
import { Icon } from 'panamera-react-ui';
import CTA from "../../../Components/CTA/CTA";
import { isEmpty } from "../../../Helpers/bundle";
var defaultImage = {
  url: '',
  alt: ''
};
export var BookAnAppointmentViewLegacy = function BookAnAppointmentViewLegacy(_ref) {
  var name = _ref.name,
    data = _ref.data,
    metadata = _ref.metadata,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? {} : _ref$location,
    track = _ref.track,
    locationId = _ref.locationId,
    onClickAboutConditions = _ref.onClickAboutConditions,
    onTrack = _ref.onTrack,
    editIconClick = _ref.editIconClick;
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style,
    isDesktopWidget = _ref2.isDesktopWidget,
    showEditIcon = _ref2.showEditIcon,
    staticStrings = _ref2.staticStrings,
    isQuotePageRedesign = _ref2.isQuotePageRedesign,
    _ref2$q2bFlow = _ref2.q2bFlow,
    q2bFlow = _ref2$q2bFlow === void 0 ? {} : _ref2$q2bFlow;
  var _useValuationResults = useValuationResults(),
    conditions = _useValuationResults.conditions,
    displayName = _useValuationResults.displayName,
    selectedIndex = _useValuationResults.selectedIndex,
    selectedConditionText = _useValuationResults.selectedConditionText,
    onSelectingCondition = _useValuationResults.onSelectingCondition,
    minPrice = _useValuationResults.minPrice,
    maxPrice = _useValuationResults.maxPrice,
    displayYear = _useValuationResults.displayYear,
    displaySubName = _useValuationResults.displaySubName,
    displayMileage = _useValuationResults.displayMileage,
    predictionList = _useValuationResults.predictionList,
    getArrowStyle = _useValuationResults.getArrowStyle,
    getPriceStyle = _useValuationResults.getPriceStyle;
  var pathname = location.pathname,
    hash = location.hash;
  var _data$widgetImagesSec = data.widgetImagesSection,
    widgetImagesSection = _data$widgetImagesSec === void 0 ? [] : _data$widgetImagesSec,
    _data$cta = data.cta,
    _data$cta$buttons = _data$cta.buttons,
    _data$cta$buttons2 = _data$cta$buttons === void 0 ? [] : _data$cta$buttons,
    _data$cta$buttons3 = _slicedToArray(_data$cta$buttons2, 1),
    button_cta = _data$cta$buttons3[0],
    condition_cta = _data$cta.conditions,
    _data$cta$buttons4 = _data$cta.buttons,
    buttons = _data$cta$buttons4 === void 0 ? [] : _data$cta$buttons4,
    carDetailsText = data.carDetailsText,
    widgetSectionHeader = data.widgetSectionHeader,
    image = data.image,
    _data$termsText = data.termsText,
    termsText = _data$termsText.text,
    termsStyle = _data$termsText.style,
    _data$benefitsSection = data.benefitsSection,
    benefitsSection = _data$benefitsSection === void 0 ? [] : _data$benefitsSection;
  var detStr = carDetailsText && carDetailsText.text || '';
  if (detStr.indexOf('#carName#') > -1) {
    var actualCarDetails = "**".concat(displayName, ", ").concat(displayYear, "**  \n**in ").concat(selectedConditionText, " condition**");
    detStr = detStr.replace(/#carName#/g, actualCarDetails);
  }
  var renderCarDetails = function renderCarDetails() {
    if (!isEmpty(q2bFlow)) {
      return /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointmentV2__q2bCarDetailsWrapper
      }, /*#__PURE__*/React.createElement("span", {
        className: css.bookAppointmentV2__q2bPrefixSuffix
      }, q2bFlow === null || q2bFlow === void 0 ? void 0 : q2bFlow.prefix), /*#__PURE__*/React.createElement("h6", {
        className: css.bookAppointmentV2__subHeader__title
      }, displayName), /*#__PURE__*/React.createElement("span", {
        className: css.bookAppointmentV2__q2bPrefixSuffix
      }, q2bFlow === null || q2bFlow === void 0 ? void 0 : q2bFlow.suffix));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
      className: css.bookAppointmentV2__subHeader__title
    }, displayName), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__subHeader__subTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: css.carSubtitle,
      "data-aut-id": "sel_brand_title"
    }, "".concat(displaySubName, " "))), displayMileage.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__subHeaderLeft_mileage,
      "data-aut-id": "sel_brand_mileage"
    }, (displayMileage === null || displayMileage === void 0 ? void 0 : displayMileage.replace) ? displayMileage.replace(/KM|km/, '') : displayMileage, " ", /*#__PURE__*/React.createElement(Translation, {
      id: "mileage"
    })));
  };
  var getHeader = React.useCallback(function () {
    if (showEditIcon) {
      var _ref3 = widgetSectionHeader || {},
        text = _ref3.text,
        _ref3$logo = _ref3.logo,
        logo = _ref3$logo === void 0 ? defaultImage : _ref3$logo,
        _ref3$brandImage = _ref3.brandImage,
        brandImage = _ref3$brandImage === void 0 ? defaultImage : _ref3$brandImage;
      var isHomePage = pathname === '/';
      return /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointment__headerWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointment__header
      }, /*#__PURE__*/React.createElement(ImageWrapper, {
        image: brandImage,
        className: css.bookAppointment__headerImage
      }), /*#__PURE__*/React.createElement("h6", {
        className: css.bookAppointment__headerText
      }, text), /*#__PURE__*/React.createElement(ImageWrapper, {
        image: logo,
        className: css.bookAppointment__logo
      })), /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointment__subHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointment__subHeaderLeft
      }, /*#__PURE__*/React.createElement("h6", {
        className: css.bookAppointment__subHeader__title
      }, displayName), /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointment__subHeader__subTitle
      }, /*#__PURE__*/React.createElement("span", {
        className: css.carSubtitle,
        "data-aut-id": "sel_brand_title"
      }, "".concat(displaySubName, " ")), displayMileage.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: css.mileage,
        "data-aut-id": "sel_brand_mileage"
      }, displayMileage, " ", /*#__PURE__*/React.createElement(Translation, {
        id: "mileage"
      })))), !isHomePage && /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointment__subHeaderRight
      }, /*#__PURE__*/React.createElement(Translation, {
        id: "quoteAnotherCar"
      }), /*#__PURE__*/React.createElement("button", {
        className: css.bookAppointment__editBtn,
        onClick: editIconClick,
        "data-aut-id": "edit_btn"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "editSquare",
        size: 24,
        color: "primaryBase"
      })))));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageWrapper, {
      image: image,
      className: css.bookAppointment__heading
    }), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointment__subtext
    }, /*#__PURE__*/React.createElement(ReactMarkdown, {
      className: css.bookAppointment__subPos
    }, detStr)));
  }, [showEditIcon, detStr, image, editIconClick, displayName, widgetSectionHeader, displaySubName, displayMileage, pathname]);
  if (selectedIndex < 0) {
    return null;
  }
  if (isQuotePageRedesign) {
    var _cx;
    return /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2,
      style: widgetStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__headerWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__subHeader
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__subHeaderLeft
    }, renderCarDetails()))), showEditIcon && /*#__PURE__*/React.createElement("div", {
      className: cx((_cx = {}, _defineProperty(_cx, css.bookAppointmentV2__qtbEditAlign, !isEmpty(q2bFlow)), _defineProperty(_cx, css.bookAppointmentV2__subHeaderRight, isEmpty(q2bFlow)), _cx))
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__editIconWithText
    }, isEmpty(q2bFlow) && /*#__PURE__*/React.createElement("span", {
      className: css.bookAppointmentV2__editText
    }, /*#__PURE__*/React.createElement(Translation, {
      id: "quoteAnotherCar"
    })), /*#__PURE__*/React.createElement("button", {
      className: css.bookAppointmentV2__editBtn,
      onClick: editIconClick,
      "data-aut-id": "edit_btn"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "editSquare",
      size: 24,
      color: "primaryBase"
    })))), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__graph
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(css.priceContent, css.priceContent__desktop),
      style: getPriceStyle()
    }, /*#__PURE__*/React.createElement("p", null, staticStrings && staticStrings.priceCarText, " ", /*#__PURE__*/React.createElement("span", null, selectedConditionText, " ", staticStrings && staticStrings.conditionText)), /*#__PURE__*/React.createElement("div", {
      className: css.priceContent__priceRange
    }, minPrice, " - ", maxPrice)), /*#__PURE__*/React.createElement("div", {
      className: css.priceContent__arrow,
      style: getArrowStyle()
    }), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__imageLoop
    }, widgetImagesSection.map(function (imageLoop, index) {
      var imageObj = selectedIndex == index ? imageLoop.on.image : imageLoop.off.image;
      return /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return onSelectingCondition({
            value: index.toString()
          });
        },
        key: "image_".concat(index),
        id: "image_".concat(index)
      }, /*#__PURE__*/React.createElement(ImageWrapper, {
        image: imageObj
      }));
    })), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__imageText
    }, conditions.map(function (condition, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: "car_condition_".concat(condition, "_").concat(idx),
        className: cx(css.bookAppointmentV2__conditionText, _defineProperty({}, css.bookAppointmentV2__selected, selectedIndex === idx))
      }, "".concat(condition, " ").concat(staticStrings && staticStrings.conditionText));
    })), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__carProps
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__carProps__condition
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__carProps__condition_textHead
    }, staticStrings && staticStrings.conditionText, " :"), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__carProps__condition_textVal
    }, selectedConditionText)), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__carProps__features
    }, predictionList[selectedIndex] && predictionList[selectedIndex].description.map(function (description) {
      var isSelected = description.value;
      return /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointmentV2__carProps__features_prop,
        key: description.key
      }, /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointmentV2__carProps__features_prop_icon
      }, /*#__PURE__*/React.createElement(Icon, {
        size: 14,
        icon: isSelected ? 'approved' : 'attentionFilled',
        color: isSelected ? 'whatsapp' : 'primaryLight2'
      })), /*#__PURE__*/React.createElement("div", {
        className: css.bookAppointmentV2__carProps__features_prop_text
      }, description.key));
    })))), /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__ctaCont
    }, /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointmentV2__ctaGroup
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button) {
      return /*#__PURE__*/React.createElement(CTA, {
        button: button,
        customClass: css.bookAppointmentV2__ctaGroup_ctaBtn,
        widgetKey: button.name,
        track: track,
        onTrack: onTrack,
        locationId: locationId
      });
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: css.bookAppointment,
    style: widgetStyle
  }, getHeader(), /*#__PURE__*/React.createElement("div", {
    className: cx(css.priceContent, _defineProperty({}, css.priceContent__desktop, isDesktopWidget))
  }, /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__truePrice
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "true_market_price_r3"
  })), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__priceRange
  }, minPrice, " - ", maxPrice, "*"), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__conditions
  }, conditions.map(function (condition, idx) {
    return /*#__PURE__*/React.createElement(InputRadioButton, {
      key: "car_condition_".concat(condition, "_").concat(idx),
      name: "condition",
      value: idx.toString(),
      displayText: condition,
      onClick: onSelectingCondition,
      isChecked: selectedIndex === idx
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__aboutConditions,
    onClick: onClickAboutConditions,
    style: condition_cta.style
  }, condition_cta.text)), /*#__PURE__*/React.createElement("div", {
    className: css.bookAppointment__benefits
  }, benefitsSection.map(function (benefits, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.bookAppointment__benefitRow,
      key: idx
    }, benefits.icon ? /*#__PURE__*/React.createElement(Icon, {
      size: 16,
      icon: benefits.icon
    }) : null, /*#__PURE__*/React.createElement("span", {
      style: benefits.style
    }, benefits.text));
  })), button_cta && /*#__PURE__*/React.createElement("div", {
    className: css.bookAppointment__btnContainer
  }, /*#__PURE__*/React.createElement(CTA, {
    button: button_cta,
    customClass: css.ctaBtn,
    widgetKey: name,
    track: track,
    locationId: locationId
  })), /*#__PURE__*/React.createElement("div", {
    className: css.bookAppointment__terms,
    style: termsStyle
  }, termsText)), hash === condition_cta.action && /*#__PURE__*/React.createElement(ConditionModal, null));
};
export default BookAnAppointmentViewLegacy;